module.exports = __webpack_public_path__ + "static/img/u121.32420c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/source/u121.png
// module id = WN2Y
// module chunks = 1